import { render, staticRenderFns } from "./DeliveryRecord.vue?vue&type=template&id=1fa7728e&scoped=true"
import script from "./DeliveryRecord.vue?vue&type=script&lang=js"
export * from "./DeliveryRecord.vue?vue&type=script&lang=js"
import style0 from "./DeliveryRecord.vue?vue&type=style&index=0&id=1fa7728e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7728e",
  null
  
)

export default component.exports